import { useTranslations } from "next-intl"

import { RatingStarIcon } from "@/components/ui/icons"

interface StarsProps {
  value: number
  size?: number
  className?: string
}

export const Stars = ({ value, size = 12, className }: StarsProps) => {
  const t = useTranslations("common")
  const halves = Math.round(value * 2) / 2
  return (
    <span
      role="img"
      aria-label={t("starsOutOfFive", { value: Math.round(value * 10) / 10 })}
      className={`inline-flex shrink-0 items-center ${className ?? ""}`}
      style={{ gap: size / 9 }}
    >
      {[0, 1, 2, 3, 4].map((index) => {
        const fill = Math.min(1, Math.max(0, halves - index))
        return (
          <span key={index} className="relative inline-flex shrink-0" style={{ width: size, height: size }}>
            <RatingStarIcon size={size} filled={false} aria-hidden className="absolute inset-0" />
            {fill > 0 && (
              <span className="absolute inset-y-0 left-0 overflow-hidden" style={{ width: `${fill * 100}%` }}>
                <RatingStarIcon size={size} filled aria-hidden />
              </span>
            )}
          </span>
        )
      })}
    </span>
  )
}
